<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t("lang.shipments") }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                v-if="hasPerm('shipment_planners.create')"
                                @invoke-method="invokeMethod($event)"
                                action="openShipmentPlannerForm"
                            ></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetShipmentPlanners(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="filter.status == '1' ? $t('lang.active') : $t('lang.inactive')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="shipment_planners" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openShipmentPlannerForm(props.item)">
                                <td class="text-center">{{ props.item.shipment_id }}</td>
                                <td>{{ props.item.company }}</td>
                                <td>{{ props.item.truck_name }}</td>
                                <td>{{ props.item.load_date }}</td>
                                <td>{{ props.item.deliver_date }}</td>
                                <td>{{ props.item.delivered_by }}</td>
                                <td class="text-center">
                                    <v-chip small :color="props.item.status_class" text-color="white">{{ props.item.status }}</v-chip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="shipment_planners"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog v-if="shipment_planner_dialog == true" :value="shipment_planner_dialog">
                <v-card>
                    <v-form ref="form_shipment_planner">
                        <v-card-title>
                            <span class="headline">{{ shipment_planner.shipment_id ? $t("lang.edit_shipment_planner") : $t("lang.add_shipment") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeShipmentPlannerDialog"
                                :dialog-status="shipment_planner_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="shipment_planner.company_id"
                                            :label="$t('lang.company')"
                                            :rules="ifValid('shipment_planners.company_id')"
                                            :items="company_options"
                                            item-value="company_id"
                                            item-text="company"
                                        >
                                        </bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 v-if="shipment_planner.company_id">
                                        <bc-autocomplete
                                            v-model="shipment_planner.truck_id"
                                            :label="$t('lang.truck')"
                                            :items="filterTankerTrucks"
                                            item-value="truck_id"
                                            item-text="truck_name"
                                            :rules="ifValid('shipment_planners.truck_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 v-if="checkCompartments">
                                        <bc-autocomplete
                                            v-model="shipment_planner.trailer_id"
                                            :label="$t('lang.trailer')"
                                            :items="filterTankerTruckTrailers"
                                            item-value="truck_id"
                                            item-text="truck_name"
                                            :rules="ifValid('shipment_planners.trailer_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="shipment_planner.shipment_id" color="error" @mouseup.left="$refs.delete_shipment_planners.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeShipmentPlannerDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveShipmentPlanners">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_shipment_planners"
                :heading="$t('lang.delete_shipment_planner')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteShipmentPlanners(shipment_planner.shipment_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openShipmentPlannerForm" },
                { title: this.$t("lang.refresh"), action: "dbGetShipmentPlanners", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.shipment_number"), sortable: false, width: "12%", align: "center" },
                { text: this.$t("lang.company"), sortable: false, width: "12%" },
                { text: this.$t("lang.truck_name"), sortable: false, width: "12%" },
                { text: this.$t("lang.load_date"), sortable: false, width: "12%" },
                { text: this.$t("lang.deliver_date"), sortable: false, width: "12%" },
                { text: this.$t("lang.delivered_by"), sortable: false, width: "12%" },
                { text: this.$t("lang.status"), sortable: false, width: "12%", align: "center" },
            ],
            enableAddModal: true,
            enableEditModal: false,
            customers: null,
            shipment_planner: {},
            filter: {
                search: "",
                status: "1",
                company_id: "",
            },
            shipment_planner_dialog: false,
            dbGetShipmentPlanners: _.debounce(this.getShipmentPlanners, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchShipmentPlanners", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.shipment_planners) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchShipmentPlanners({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.shipment_planners) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.shipment_planners.shipment_planners_filter,
            page: (state) => state.shipment_planners.page,
            rules_shipment_planners: (state) => state.shipment_planners.rules_shipment_planners,
            shipment_planner_status_options: (state) => state.settings.shipment_planner_status_options,
            shipment_planners: (state) => state.shipment_planners.shipment_planners,
            tanker_trucks: (state) => state.tanker_trucks.tanker_truck_options,
            company_options: (state) => state.companies.company_options,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        filterTankerTrucks() {
            return this.tanker_trucks.length > 0
                ? this.tanker_trucks.filter((truck) => truck.company_id == this.shipment_planner.company_id && truck.vehicle_type == "truck")
                : [];
        },
        filterTankerTruckTrailers() {
            return this.tanker_trucks.length > 0
                ? this.tanker_trucks.filter((truck) => truck.company_id == this.shipment_planner.company_id && truck.vehicle_type == "trailer")
                : [];
        },
        checkCompartments() {
            if (this.shipment_planner.truck_id) {
                let truck = this.tanker_trucks.find((truck) => truck.truck_id == this.shipment_planner.truck_id);
                return truck.num_of_compartments <= 0 ? true : false;
            }
        },
    },
    methods: {
        ...mapActions(["fetchShipmentPlanners", "saveShipmentPlanner", "deleteShipmentPlanner", "fetchTankerTrucks", "fetchCompanies"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openShipmentPlannerForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_shipment_planner) item ? this.$refs.form_shipment_planner.resetValidation() : this.$refs.form_shipment_planner.reset();

                    this.$nextTick(() => {
                        this.shipment_planner = item != null ? this.assignObj2(item, this.rules_shipment_planners) : {};
                        this.shipment_planner_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "shipment_planner", params: { id: item.shipment_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_shipment_planner) item ? this.$refs.form_shipment_planner.resetValidation() : this.$refs.form_shipment_planner.reset();
                    this.shipment_planner_dialog = true;
                } else {
                    this.$router.push({ name: "shipment_planner" });
                }
            }

            this.fetchTankerTrucks({ body: { options: 1 } });
            this.fetchCompanies({ body: { options: 1 } });
        },
        saveShipmentPlanners() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_shipment_planner")) {
                    let body = this.prepForm(this.shipment_planner, this.rules_shipment_planners);

                    this.saveShipmentPlanner({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getShipmentPlanners();
                                this.closeShipmentPlannerDialog();
                            } else {
                                this.$router.push({ name: "shipment_planner", params: { id: data.shipment_planner.shipment_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteShipmentPlanners(id = null) {
            this.deleteShipmentPlanner({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getShipmentPlanners();
                    this.closeShipmentPlannerDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeShipmentPlannerDialog() {
            this.shipment_planner_dialog = false;
            this.$refs.delete_shipment_planners.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getShipmentPlanners(pg_refresh = false) {
            this.startLoader();

            this.fetchShipmentPlanners({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.shipment_planner_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        async refresh(force = false) {},
    },
    mounted() {
        this.refresh();
    },
};
</script>
